import React from 'react';
import styled from 'styled-components';
import { useMediaQueryContext, useModalContext } from '@fourthwall/components';
import { useOnceInView, useTagManager } from '@hooks';
import { useRecommendationsDismiss } from '../../../Recommendations/hooks/useRecommendationsDismiss';
import { useCartAbandonmentEmailPromoRecommendation } from '../../../Recommendations/modules/CartAbandonmentEmailPromoRecommendation';
import * as Carousel from '../../components/Carousel/Carousel';
import { MiniRecommendationDismissButton } from '../../components/MiniRecommendationDismissButton/MiniRecommendationDismissButton';
import { ConfirmEmailPromoCodeModal } from './ConfirmEmailPromoCodeModal/ConfirmEmailPromoCodeModal';
const ID = 'abandonmentDiscount';
const CarouselItem = styled(Carousel.Item) `
  background-color: rgba(0, 156, 224, 0.15);

  &:hover {
    background-color: rgba(0, 156, 224, 0.25);
  }
`;
export const AbandonmentDiscountSlide = ({ 'data-role': dataRole, resetSlider, }) => {
    const { open, close } = useModalContext();
    const { tablet } = useMediaQueryContext();
    const tagManager = useTagManager();
    const { recommendationsDismiss } = useRecommendationsDismiss();
    const { cartAbandonmentEmailPromoRecommendation, includePromoCode } = useCartAbandonmentEmailPromoRecommendation();
    const viewRef = useOnceInView(() => {
        tagManager.trigger('mini_recommendation_view', {
            type: ID,
        });
    });
    if (!cartAbandonmentEmailPromoRecommendation.enabled ||
        !recommendationsDismiss.promotions.visible) {
        return null;
    }
    const handleConfirmEmailPromoCode = () => {
        open(ConfirmEmailPromoCodeModal, {
            onConfirm: async () => {
                tagManager.trigger('mini_recommendation_click', {
                    type: ID,
                });
                await includePromoCode();
                close();
                setTimeout(() => {
                    resetSlider();
                }, 0);
            },
        });
    };
    return (React.createElement(CarouselItem, { ref: viewRef, "data-role": dataRole, "data-analytics": ID, onClick: handleConfirmEmailPromoCode },
        React.createElement(Carousel.ContentLeft, null,
            React.createElement(Carousel.ItemEmote, null, "\uD83D\uDCE8"),
            !tablet && React.createElement(Carousel.ItemText, null, " Add 5% off for abandoned carts"),
            tablet && (React.createElement(Carousel.ItemText, null, "Tip: Offer 5% off in checkout abandonment emails"))),
        recommendationsDismiss.promotions.visible && (React.createElement(MiniRecommendationDismissButton, { onDismiss: () => {
                recommendationsDismiss.promotions.dismiss();
                tagManager.trigger('mini_recommendation_dismiss', {
                    type: ID,
                });
                setTimeout(() => {
                    resetSlider();
                }, 0);
            } }))));
};
